export default __webpack_public_path__ + "static/media/Path3536.cf1e233b.svg";